import React from "react";
import ProductViewBasicCard from "../ProductViewBasicCard";
import ProductViewBrandCard from "../ProductViewBrandCard";
import ProductViewSimilarCard from "../ProductViewSimilarCard";

const ProductViewDetails = React.memo(
	({
		data,
		setProductViewData,
		setActiveImage,
		navToTop,
		error,
		extraPadding,
		offsetTop,
		productViewEventProps,
	}) => {
		if (!data) {
			return;
		}

		const { product, brand, similar_products: similarProducts } = data;

		return (
			<>
				<ProductViewBasicCard
					product={product}
					brand={brand}
					setActiveImage={setActiveImage}
					error={error}
					navToTop={navToTop}
					extraPadding={extraPadding}
					productViewEventProps={productViewEventProps}
				/>
				<ProductViewBrandCard
					brand={brand}
					productViewEventProps={productViewEventProps}
				/>
				<ProductViewSimilarCard
					product={product}
					similarProducts={similarProducts}
					setProductViewData={setProductViewData}
					navToTop={navToTop}
					offsetTop={offsetTop}
					productViewEventProps={productViewEventProps}
				/>
			</>
		);
	}
);

export default ProductViewDetails;
